import { render, staticRenderFns } from "./resultBox.vue?vue&type=template&id=90b98fdc&scoped=true"
import script from "./resultBox.vue?vue&type=script&lang=js"
export * from "./resultBox.vue?vue&type=script&lang=js"
import style0 from "./resultBox.vue?vue&type=style&index=0&id=90b98fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b98fdc",
  null
  
)

export default component.exports